/**
 * PATH: packages/ui/src/qa/qaItemStatus.ts
 * FILE_ID: UI-QA-ITEM-STATUS-001
 * PURPOSE: Shared QA item-status values and selected-state mapping.
 * WHY: QA hub and Jobs run rows must write the same four statuses.
 */

export const QA_ITEM_STATUS_BUTTONS = [
  { id: 'pass', label: 'Pass', write: 'done', selectedWhen: ['done', 'pass'] },
  { id: 'fail', label: 'Fail', write: 'failed', selectedWhen: ['failed'] },
  { id: 'further_action', label: 'F A', write: 'further_action', selectedWhen: ['further_action'] },
  { id: 'na', label: 'N/A', write: 'not_applicable', selectedWhen: ['not_applicable'] },
] as const

export type QaItemStatusWrite = (typeof QA_ITEM_STATUS_BUTTONS)[number]['write']

export function isQaItemStatusSelected(current: string, selectedWhen: readonly string[]): boolean {
  return selectedWhen.includes(current)
}
